import { Component } from '@angular/core';

@Component({
  selector: 'app-vcl-detail-ins-mod',
  templateUrl: './vcl-detail-ins-mod.component.html',
  styleUrls: ['./vcl-detail-ins-mod.component.scss']
})
export class VclDetailInsModComponent {

}
